/**
 * Learn more about theme events at
 * https://help.switchthemes.co/shapes/developer/theme-events/overview.html
 */

window.theme = window.theme || {};

window.theme.events = {
  version: '1.0',
};

/**
 * Rimozione a cascata dei prodotti "box"
 * Se un prodotto appartiene a un gruppo box (property "Box") viene rimosso
 * (link "Rimuovi") oppure gli viene diminuita la quantità (tasto "-"),
 * rimuove automaticamente anche tutti gli altri prodotti dello stesso
 * gruppo. In entrambi i casi il comportamento è identico: svuota subito
 * l'intera box, senza mai effettuare il singolo decremento.
 */
function getBoxGroupItems(groupId) {
  return Array.from(
    document.querySelectorAll('[data-line-item-key]')
  ).filter((item) => item.dataset.boxGroup === groupId);
}

async function removeBoxGroup(groupId) {
  if (window.__boxGroupRemovalInProgress === groupId) return;

  const items = getBoxGroupItems(groupId);
  const keys = items
    .map((item) => item.dataset.lineItemKey)
    .filter(Boolean);

  if (!keys.length) return;

  window.__boxGroupRemovalInProgress = groupId;

  const updates = {};
  keys.forEach((key) => {
    updates[key] = 0;
  });

  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ updates }),
    });

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      const message =
        data.description ||
        data.message ||
        theme.strings.cartError;

      const errorsEl = document.getElementById('cart-errors');
      if (errorsEl) errorsEl.textContent = message;

      document.dispatchEvent(
        new CustomEvent('theme:cart:error:other', {
          detail: {
            message,
            error: data,
          },
        })
      );
      return;
    }

    // Chiede al tema di rileggere e ridisegnare il carrello
    document.dispatchEvent(new CustomEvent('theme:update:cart'));
  } catch (error) {
    console.error('[box-removal]', error);
    const message = theme.strings.cartError;

    const errorsEl = document.getElementById('cart-errors');
    if (errorsEl) errorsEl.textContent = message;

    document.dispatchEvent(
      new CustomEvent('theme:cart:error:other', {
        detail: {
          message,
          error,
        },
      })
    );
  } finally {
    setTimeout(() => {
      window.__boxGroupRemovalInProgress = null;
    }, 0);
  }
}

/**
 * Dato un elemento cliccato, risale fino al <li data-line-item-key
 * data-box-group> e restituisce il groupId, oppure null se l'elemento non
 * appartiene a nessuna box.
 */
function getClickedBoxGroupId(el) {
  const lineItem = el.closest('[data-box-group]');
  if (!lineItem) return null;

  const groupId = lineItem.dataset.boxGroup;
  if (!groupId || groupId === '') return null;

  return groupId;
}

/**
 * Verifica se il bottone cliccato è il tasto "-" (decrementa) del
 * quantity-selector, individuandolo per posizione nel DOM rispetto
 * all'input della quantità: il bottone "-" precede sempre l'input,
 * il bottone "+" lo segue. In questo modo non dipendiamo dal testo/aria
 * -label del bottone (che passa per entità HTML) né dall'implementazione
 * interna del componente Alpine "CartItemQuantity".
 */
function isQuantityMinusButton(button) {
  const quantityControl =
    button.closest('[x-data="CartItemQuantity"]') || button.parentElement;
  if (!quantityControl) return false;

  const input = quantityControl.querySelector('input[name="updates[]"]');
  if (!input || input === button) return false;

  const position = button.compareDocumentPosition(input);
  return Boolean(position & Node.DOCUMENT_POSITION_FOLLOWING);
}

/**
 * Intercetta, in capture phase (quindi PRIMA che Alpine gestisca il
 * click con @click.prevent.stop="decrement"/"remove"), i click su:
 * - il link "Rimuovi" di un prodotto in una box
 * - il tasto "-" del quantity-selector di un prodotto in una box
 * In entrambi i casi blocca l'azione singola di Alpine e rimuove
 * subito l'intero gruppo box.
 */
document.addEventListener(
  'click',
  (event) => {
    const removeLink = event.target.closest('a[href*="cart/change"]');
    const minusButton = event.target.closest('button');

    let groupId = null;

    if (removeLink) {
      groupId = getClickedBoxGroupId(removeLink);
    } else if (minusButton && isQuantityMinusButton(minusButton)) {
      groupId = getClickedBoxGroupId(minusButton);
    }

    if (!groupId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    removeBoxGroup(groupId);
  },
  true
);

document.addEventListener('theme:update:cart', async () => {
  document.dispatchEvent(new CustomEvent('shapes:cart:lock'));

  try {
    const response = await fetch(
      `${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count,cart-live-region`
    );
    const data = await response.json();

    if (!data.status) {
      document.dispatchEvent(
        new CustomEvent('shapes:cart:update', {
          bubbles: true,
          detail: {
            response: {
              sections: {
                ...data,
              },
            },
          },
        })
      );
    }
  } catch (e) {
    console.error(e);
    document.getElementById('cart-errors').textContent =
      theme.strings.cartError;
    document.dispatchEvent(
      new CustomEvent('theme:cart:error:other', {
        detail: {
          message: theme.strings.cartError,
          error: e,
        },
      })
    );
  } finally {
    document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
  }
});

const getCartDrawerEl = () => {
  return document.querySelector('[data-cart-drawer]');
};

document.addEventListener('cart-will-open', async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:opening', {
      detail,
    })
  );
});

document.addEventListener('cart-is-open', async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:open', {
      detail,
    })
  );
});

document.addEventListener('cart-will-close', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closing', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('cart-is-closed', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closed', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('theme:open:cart-drawer', () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').closeAll();

    Alpine.store('modals').open('cart');
  }
});

document.addEventListener('theme:close:cart-drawer', () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').close('cart');
  }
});

const cartChangeEventHandler = (e) => {
  const { cartItemCount, itemsRootEl, lineItemEl, variantId, key } = e.detail;

  document.dispatchEvent(
    new CustomEvent('theme:cart:change', {
      detail: {
        type: e.type,
        cartItemCount,
        itemsRootEl,
        lineItemEl,
        variantId,
        key,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener('theme:product:add', cartChangeEventHandler);
document.addEventListener('theme:line-item:change', cartChangeEventHandler);

const cartErrorEventHandler = (e) => {
  document.dispatchEvent(
    new CustomEvent('theme:cart:error', {
      detail: {
        type: e.type,
        message: e.detail.message,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener(
  'theme:product:error:add-to-cart',
  cartErrorEventHandler
);

document.addEventListener('theme:line-item:error', cartErrorEventHandler);
document.addEventListener('theme:cart:error:other', cartErrorEventHandler);

/**
 * Set `window.themeEventsDebugMode` to `true` to log events
 * outside the theme editor
 */

if (Shopify.designMode || window.themeEventsDebugMode) {
  const themeEvents = [
    'theme:variant:change',
    'theme:product:add',
    'theme:line-item:change',
    'theme:cart:change',
    'theme:cart:update',
    'theme:cart-drawer:opening',
    'theme:cart-drawer:open',
    'theme:cart-drawer:closing',
    'theme:cart-drawer:closed',
    'theme:product:error:add-to-cart',
    'theme:line-item:error',
    'theme:cart:error:other',
    'theme:cart:error',
  ];

  const aggregateEvents = ['theme:cart:change', 'theme:cart:error'];

  for (const eventName of themeEvents) {
    let color;

    if (eventName.includes('error')) {
      color = '#ef4444';
    } else {
      color = '#22c55e';
    }

    const message = [
      `%c\u25CF %c${eventName}`,
      `color: ${color};`,
      'font-weight: bold;',
    ];

    if (aggregateEvents.includes(eventName)) {
      document.addEventListener(eventName, (e) => {
        console.groupCollapsed(...message);
        console.log(
          `Underlying event: %c${e.detail.type}`,
          'font-weight: bold;'
        );
        console.log('Event detail:', e.detail);
        console.groupEnd();
      });
    } else {
      document.addEventListener(eventName, (e) => {
        console.log(...message, e.detail);
      });
    }
  }
}